// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"MSSP-module--pageContainer--3WWP6","approachSection":"MSSP-module--approachSection--azeNn"};